<template>
  <div :id="id" class="content" :style="`height: ${curHeight}`">
    <div class="content-box">
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img src="../../../assets/images/foreign_enterprise_service.png" />
          <p>{{resource["RES476296E56A16741"]}}</p>
          <p class="second-title qiye">
            <span v-for="item in enterpriseInfo" :key="item.moduleCode" style="margin: 0 5px;" @click="navDetailByContentCode('企业服务',item)" @mouseenter="mouseOver(item, '710px')">{{ item.moduleName }}</span>
          </p>
        </div>
        <div v-for="item in enterpriseInfo" :key="item.moduleCode">
          <div v-if="mouseModuleCode === item.moduleCode" class="hover-content hover-enter-service">
            <div class="hover-box design-html" v-html="moduleEnterpriseMap[item.contentCode]" :style="{
            '--beforeLeft': 142 + 'px',
            '--afterLeft': 142 + 'px',
            }">
            </div>
            <div class="more" @click="navDetailByContentCode('企业服务',item)">
              显示更多
              <a-icon type="down" style="color: #cab484" />
            </div>
          </div>
        </div>
      </div>

      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img src="../../../assets/images/foreign_enterprise_staff.png" />
          <p>{{resource["RESB85E3E92C042D49"]}}</p>
          <p class="second-title">
            <span v-for="item in serviceStaffInfo" :key="item.moduleCode" class="etc" @click="navDetailByModuleCode('员工服务', item) " @mouseenter="mouseOver(item, '710px')">{{ item.moduleName }}</span>
          </p>
        </div>
        <div v-for="item in serviceStaffInfo" :key="item.moduleCode">
          <div class="hover-content hover-staff" v-if="mouseModuleCode === item.moduleCode" v-bind:style="{
            left: -395 + 'px',
            width: 1140 + 'px',
          }">
            <div class="hover-box" v-bind:style="{
              // 'overflow-y': open ? 'scroll' : 'hidden',
              '--beforeLeft': 553 + 'px',
              '--afterLeft': 552 + 'px',
            }">
              <div style="font-size: 20px; padding-bottom: 20px; padding-left: 23px;font-weight: bold">{{
                  item.moduleName
                }}
              </div>
              <div class="hover-list" v-for="subItem in moduleServiceStaffMap[item.moduleCode]" :key="subItem.contentTitle" @click="goDetail('员工服务',subItem.contentCode, subItem,serviceStaffInfo)">
                <div>{{ subItem.contentTitle }}</div>
                <span style="float: right">{{String(subItem.createTime).split(" ")[0]}}</span>
                <a-divider dashed />
              </div>
            </div>
            <div class="more" v-if="!open" @click="navDetailByModuleCode('员工服务', item) ">
              显示更多
              <a-icon type="down" style="color: #cab484" />
            </div>
          </div>
        </div>
      </div>
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img src="../../../assets/images/foreign_enterprise_policy.png" />
          <p>{{resource["RES54589D356BDA145"]}}</p>
          <p class="second-title">
            <span v-for="item in policyGuideInfo" :key="item.moduleCode" style="margin: 0 0.3em;" @click="navDetailByModuleCode('政策导航', item) " @mouseenter="mouseOver(item, '710px')">{{ item.moduleName }}</span>
          </p>
        </div>
        <div v-for="item in policyGuideInfo" :key="item.moduleCode">
          <div class="hover-content hover-staff" v-if="mouseModuleCode === item.moduleCode" v-bind:style="{
            'overflow-y': open ? 'scroll' : 'hidden',
            left: -790 + 'px',
            width: 1140 + 'px',
          }">
            <div class="hover-box" v-bind:style="{
              '--beforeLeft': 953 + 'px',
              '--afterLeft': 952 + 'px',
            }">
              <div class="subtitle" style="font-size: 20px; padding-bottom: 20px; padding-left: 23px;font-weight: bold;">
                {{ item.moduleName }}
              </div>
              <div class="hover-list" v-for="subItem in modulePolicyGuideMap[item.moduleCode]" :key="subItem.contentTitle" @click="goDetail('政策导航',subItem.contentCode, subItem,policyGuideInfo)">
                <div>{{ subItem.contentTitle }}</div>
                <span style="float: right">{{ String(subItem.createTime).split(" ")[0] }}</span>
                <a-divider dashed />
              </div>
            </div>
            <div class="more" v-if="!open" @click="navDetailByModuleCode('政策导航', item)">
              显示更多
              <a-icon type="down" style="color: #cab484" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { getInfoByGet, getModuleInfo, getModuleChild, getResource } from "@/api/moduleContent";
import { getInterpreter } from "@/api/translation.js";
import { pushContentAnnounceHtmlContent, pushModuleAnnounceHtmlContent } from "../../../util/navUtils";

export default {
  name: "hover-box",
  props: {
    id: {
      default: "",
      type: String,
    },
  },
  data () {
    return {
      curHeight: "280px", // 280px
      mouseModuleCode: '',
      mouseModuleItem: null,
      open: false,
      enterpriseInfo: [],
      moduleEnterpriseMap: {},
      serviceStaffInfo: [],
      moduleServiceStaffMap: {},
      policyGuideInfo: [],
      modulePolicyGuideMap: {},
      resource: {}
    };
  },
  created () {
    this.mouseModuleCode = this._.get(this, '$route.query.m', '')
    this.curHeight = this._.get(this, '$route.query.h', '280px')
    this.getResource()
    this.getEnterpriseInfo();
    this.getServiceStaffInfo();
    this.getPolicyGuideInfo();
  },
  methods: {
    getResource () {
      getResource("RESCFF81E7E2CD30B5").then(res => {
        res.data.records && res.data.records.forEach(e => {
          // 企业服务
          if (e.resourceCode === "RES476296E56A16741") {
            this.resource["RES476296E56A16741"] = e.resourceName
          }
          // 员工服务
          if (e.resourceCode === "RESB85E3E92C042D49") {
            this.resource["RESB85E3E92C042D49"] = e.resourceName
          }
          // 政策导航
          if (e.resourceCode === "RES54589D356BDA145") {
            this.resource["RES54589D356BDA145"] = e.resourceName
          }
        })
        console.log("this.resource", this.resource)
      })
    },
    // 获取企业服务
    getEnterpriseInfo () {
      getModuleInfo('RES476296E56A16741').then((res) => {
        this.enterpriseInfo = [];
        let enterpriseChildArr = res.data.records.map((item) => {
          this.enterpriseInfo.push({ ...item });
          return getModuleChild(item.moduleCode, 'contentAnnounce');
        })
        return Promise.all(enterpriseChildArr)
      }).then((arr) => {
        const enterpriseChildInfoArr = arr.map(item => {
          const { contentCode, moduleCode } = item.data.records[0];
          this.enterpriseInfo.forEach((val) => {
            if (val.moduleCode === moduleCode) {
              val['contentCode'] = contentCode;
            }
          })
          return getInfoByGet(contentCode);
        })
        return Promise.all(enterpriseChildInfoArr)
      }).then((datas) => {
        for (let index in datas) {
          const { contentHtml, contentCode, contentTitle } = datas[index].data;
          this.enterpriseInfo.forEach((val) => {
            if (val.contentCode === contentCode) {
              val['contentTitle'] = contentTitle;
            }
          })
          this.$set(this.moduleEnterpriseMap, contentCode, contentHtml);
        }
      })
    },
    getServiceStaffInfo () {
      getModuleInfo('RESB85E3E92C042D49').then((res) => {
        this.serviceStaffInfo = [];
        const serviceStaffChildArr = res.data.records.map((item) => {
          this.serviceStaffInfo.push({ ...item });
          return getModuleChild(item.moduleCode, 'contentAnnounce');
        })
        return Promise.all(serviceStaffChildArr)
      }).then((arr) => {
        arr.map(item => {
          const { moduleCode } = item.data.records[0];
          this.moduleServiceStaffMap[moduleCode] = item.data.records;
        })
      })
    },
    getPolicyGuideInfo () {
      getModuleInfo('RES54589D356BDA145').then((res) => {
        this.policyGuideInfo = [];
        const policyGuideChildArr = res.data.records.map((item) => {
          this.policyGuideInfo.push({ ...item });
          return getModuleChild(item.moduleCode, 'contentAnnounce');
        })
        return Promise.all(policyGuideChildArr)
      }).then((arr) => {
        arr.map(item => {
          const { moduleCode } = item.data.records[0];
          this.modulePolicyGuideMap[moduleCode] = item.data.records;
        })
      })
    },

    goDetail (parentName,contentCode, subItem,list) {
      const name=list.find((item)=>item.moduleCode===subItem.moduleCode).moduleName
      this.pushRouter(`/guide?type=contentAnnounce&contentCode=${contentCode}&linkname=外企服务/${parentName}/${name}/详情`)
    },
    navDetailByContentCode (parentName, moduleItem) {
      let linkname = `外企服务/${parentName}/${moduleItem.moduleName}`
      pushContentAnnounceHtmlContent(this, moduleItem.contentCode, moduleItem.moduleName, linkname);
    },

    navDetailByModuleCode (parentName, moduleItem) {
      let linkname = `外企服务/${parentName}/${moduleItem.moduleName}`
      pushModuleAnnounceHtmlContent(this, moduleItem.moduleCode, moduleItem.moduleName, linkname);
    },
    // 移入
    mouseOver (moduleItem, height) {
      this.curHeight = height || '780px';
      this.mouseModuleCode = moduleItem.moduleCode;
      this.mouseModuleItem = moduleItem;
      this.open = false;
    },
    // 移出
    mouseLeave () {
      this.curHeight = "280px";
      this.mouseModuleCode = "";
      this.mouseModuleItem = null;
      this.open = false;
    },
  },
};
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  position: relative;
  margin-top: 40px;

  &-box {
    width: 1140px;
    position: relative;
    margin: auto;
    // left: 50%;
    // transform: translateX(-50%);
    text-align: left;
    font-size: 0px;
  }
}

.hover-content {
  font-size: 16px;
}

.box:not(:last-of-type) {
  margin-right: 45px;
}

.box:hover {
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
}

.box {
  width: 350px;
  height: 260px;
  display: inline-block;
  border: 1px solid #e5e5e5;
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.04);
  text-align: center;
  cursor: default;
  position: relative;

  .box-item {
    position: relative;
    top: 22px;
    width: 350px;
    height: 260px;
  }

  img {
    width: 64px;
    height: 64px;
    margin-top: 39px;
  }

  p {
    margin: 0;
    padding: 0;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    margin-top: 23px;
  }

  p:last-of-type {
    margin-top: 1px;

    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7f7f7f;
      cursor: pointer;
    }

    span:hover {
      color: #cbb486;
    }
  }

  .hover-title {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    margin-top: 20px;
    margin-bottom: 25px;
  }

  .hover-title:not(first-of-type) {
    margin-top: 10px;
  }

  .hover-desc {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3a3a3a;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

/deep/.hover-content {
  width: 1140px;
  height: 530px;
  overflow: hidden;
  position: absolute;
  top: 281px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  padding: 30px;
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
}
/deep/.hover-staff {
  height: 460px;
}
/deep/.hover-enter-service {
  height: 460px;
}
// /deep/ .hover-box p {
//   text-indent: 2em;
// }
/deep/ .hover-box p strong {
  text-indent: 0 !important;
  font-size: 20px;
}

.hover-box {
  text-align: left;
  text-align: justify;

  p {
    padding: 0;
    margin: 0;
    padding-bottom: 15px;
  }

  div:hover {
    color: #cbb486;
  }

  div:hover .down-btn {
    display: inline-block;
  }

  .boxx {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3d4652;
    line-height: 68px;
    border-bottom: 1px solid #eee;
    padding-left: 15px;
    position: relative;
    white-space: nowrap;

    .down-btn {
      line-height: 36px;
      color: #cbb486;
    }

    img {
      line-height: 36px;
      margin-top: 0px;
    }
  }

  .boxx::before {
    content: "";
    display: inline-block;
    border-radius: 50%;
    width: 5px;
    height: 5px;
    background: rgba(203, 180, 134, 1);
    position: absolute;
    left: -1px;
    top: 31px;
  }
}

// .hover-box:first-of-type {
//   margin-right: 40px;
// }

.down-btn {
  display: inline-block;
  display: none;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid #cbb486;
  vertical-align: middle;
  text-align: center;

  img {
    width: 16px;
    height: 16px;
  }
}

.more {
  font-size: 16px;
  cursor: pointer;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #cab484;
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
}

.hover-box::before {
  display: inline-block;
  box-sizing: content-box;
  width: 0px;
  height: 0px;
  position: absolute;
  top: -16px;
  left: 143px;
  left: var(--beforeLeft);
  padding: 0;
  border-bottom: 8px solid #ffffff;
  border-top: 8px solid transparent;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  display: block;
  content: "";
  z-index: 12;
}

.hover-box::after {
  box-sizing: content-box;
  display: inline-block;
  width: 0px;
  height: 0px;
  position: absolute;
  top: -18px;
  //left:142px;
  left: var(--afterLeft);
  padding: 0;
  border-bottom: 9px dotted #cbb486;
  border-top: 9px solid transparent;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  display: block;
  content: "";
  z-index: 10;
}

.hover-title {
  width: 50%;
  display: inline-block;
}

.hover-desc {
  width: 80%;
  //  display: inline-block;
  position: relative;
  padding-left: 20px;
  /* padding-top: 21px; */
  /* padding-bottom: 21px; */
  white-space: nowrap;
  overflow: hidden;

  &::after {
    position: absolute;
    display: inline-block;
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #cbb486;
    left: 0px;
    top: 15%;
  }
}

.hover-list {
  width: 1055px;
  font-size: 16px;
  margin-bottom: 25px;
  padding-left: 25px;
  height: 40px;
  & > div:nth-of-type(1) {
    width: 70%;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
  }
}

.hover-list::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #cbb486;
  border-radius: 50%;
  transform: translate(-10px, -10px);
}

.more {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #cab484;
  position: absolute;
  display: block;
  height: 70px;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  background: white;
  width: 100%;
  line-height: 70px;
  text-align: center;
  // opacity: 0.8;
}

.towards {
  width: 1002px;
}

/deep/ .ant-divider {
  margin: 10px 0 !important;
}

.second-title {
  margin-top: 18px !important;
  // display: flex;
  // justify-content: ;
}

.second-title .etc {
  // display: block;
  padding-right: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/foreignCompanyService/siderContent-01.vue